import { createGlobalStyle } from 'styled-components';

import segoe from './fonts/SegoeUI.ttf';
import segoeuiRegular from './fonts/segoeui-regular.woff2';
import segoeuiSemibold from './fonts/segoeui-semibold.woff2';
import segoeuiLight from './fonts/segoeui-light.woff2';
import segoeuiSemilight from './fonts/segoeui-semilight.woff2';


import golos from './fonts/Golos/GolosText-VariableFont_wght.ttf';
import golosRegular from './fonts/Golos/GolosText-Regular.ttf';
import golosSemibold from './fonts/Golos/GolosText-SemiBold.ttf';
import golosBlack from './fonts/Golos/GolosText-Black.ttf';
import golosBold from './fonts/Golos/GolosText-Bold.ttf';
import golosExtraBold from './fonts/Golos/GolosText-ExtraBold.ttf';
import golosMedium from './fonts/Golos/GolosText-Medium.ttf';



export const GlobalStyle = createGlobalStyle`
  @font-face {
      font-family: 'Golos Text';
      src: url(${golos});
  }

  @font-face {
      font-family: 'Golos Text';
      src: url(${golosRegular}) format('truetype');
      font-weight: 400;
      font-style: normal;
  }

  @font-face {
      font-family: 'Golos Text';
      src: url(${golosMedium}) format('truetype');
      font-weight: 500;
      font-style: normal;
  }
  
  @font-face {
      font-family: 'Golos Text';
      src: url(${golosSemibold}) format('truetype');
      font-weight: 600;
      font-style: normal;
  }
  
  @font-face {
      font-family: 'Golos Text';
      src: url(${golosBold}) format('truetype');
      font-weight: 700;
      font-style: normal;
  }
  
  @font-face {
      font-family: 'Golos Text';
      src: url(${golosExtraBold}) format('truetype');
      font-weight: 800;
      font-style: normal;
  }
  
  @font-face {
      font-family: 'Golos Text';
      src: url(${golosBlack}) format('truetype');
      font-weight: 900;
      font-style: normal;
  }
    
  // @font-face {
  //   font-family: 'Segoe-UI';
  //   src: url(${segoe});
  // }
  //
  // @font-face {
  //   font-family: 'Segoe UI Web (Cyrillic)';
  //   src: url(${segoeuiRegular}) format('woff2');
  //   font-weight: 400;
  //   font-style: normal;
  // }
  //
  // @font-face {
  //   font-family: 'Segoe UI Web (Cyrillic)';
  //   src: url(${segoeuiSemibold}) format('woff2');
  //   font-weight: 600;
  //   font-style: normal;
  // }
  //
  // @font-face {
  //   font-family: 'Segoe UI Web (Cyrillic)';
  //   src: url(${segoeuiLight}) format('woff2');
  //   font-weight: 100;
  //   font-style: normal;
  // }
  //
  // @font-face {
  //   font-family: 'Segoe UI Web (Cyrillic)';
  //   src: url(${segoeuiSemilight}) format('woff');
  //   font-weight: 300;
  //   font-style: normal;
  // }

  body {
    background-color: #FFFFFF;
    margin: 0;
    font-family: 'Golos Text', sans-serif;
    color: #333333;
  }
  *, ::after, ::before {
    box-sizing: border-box;
    padding: 0;
  }
  img {
    height: 100%;
  }
  .ms-fontWeight-bold {
    font-weight: 700;
  }
`;
